<template>
  <fragment>
    <b-badge :variant="variant">{{ status }}</b-badge>
    <button v-if="isAdmin && status != statuses[2]" class="btn btn-small" @click.prevent="iNextStatus">»</button>
  </fragment>
</template>

<script>
import logger from '@/logger';

export default {
  name: 'StatusView',
  data() {
    return {
      statuses: ['DRAFT', 'DOING', 'FINISH'],
    };
  },
  props: {
    status: {
      type: String,
      required: true,
    },
    isAdmin: {
      type: Boolean,
    },
    nextStatus: {
      type: Function,
      default: s => {
        logger.debug('nextStatus:', s);
      },
    },
  },
  computed: {
    variant() {
      let v = 'light';
      switch (this.status) {
        case this.statuses[0]:
          v = 'secondary';
          break;
        case this.statuses[1]:
          v = 'success';
          break;
        case this.statuses[2]:
          v = 'info';
          break;
      }
      return v;
    },
  },
  methods: {
    iNextStatus() {
      let idx = this.statuses.indexOf(this.status);
      idx++;

      if (idx < this.statuses.length) {
        // TODO show warning
        this.$emit('nextStatus', this.statuses[idx]);
      }
    },
  },
};
</script>
